customElements.get("header-menu") || customElements.define("header-menu", class extends HTMLElement {
  constructor() {
    super(), this.details = this.querySelector("details.header--level1"), this.megaMenu = this.querySelector('[id^="MegaMenu-Content-"]'), 
    this.fadeTimeouts = new Map, this.isDesktop = window.matchMedia("(min-width: 1025px)"), 
    this.closeButtons = Array.from(this.querySelectorAll("button[data-close-menu]")), 
    this.close = this.close.bind(this);
  }
  connectedCallback() {
    this.handleMediaChange(this.isDesktop), this.isDesktop.addEventListener("change", this.handleMediaChange), 
    this.closeButtons.length && this.closeButtons.forEach(e => e.addEventListener("click", this.close));
  }
  disconnectedCallback() {
    this.isDesktop.removeEventListener("change", this.handleMediaChange), this.removeDesktopListeners(), 
    this.clearAllFadeTimeouts(), this.closeButtons.length && this.closeButtons.forEach(e => e.removeEventListener("click", this.close));
  }
  handleMediaChange=e => {
    e.matches ? this.addDesktopListeners() : (this.removeDesktopListeners(), this.close());
  };
  onToggle=e => {
    const t = "open" === e.newState;
    this.megaMenu.setAttribute("aria-hidden", !t), this.megaMenu.setAttribute("tabindex", t ? "0" : "-1");
  };
  handleSubMenuHover=e => {
    const t = e.target.closest("a"), s = e.target.closest('[id^="SubMenu-Content"]');
    if (!t || !s) return;
    const i = s.querySelector(".header__hover-bullet");
    if (!i) return;
    const o = s.id;
    if (this.fadeTimeouts.has(o) && (clearTimeout(this.fadeTimeouts.get(o)), this.fadeTimeouts.delete(o)), 
    "mouseover" === e.type) {
      const e = t.offsetTop - s.offsetTop;
      i.style.transform = `translateY(${e}px)`, i.classList.remove("opacity-0");
    } else if ("mouseout" === e.type) {
      const e = setTimeout(() => {
        i.classList.add("opacity-0"), this.fadeTimeouts.delete(o);
      }, 300);
      this.fadeTimeouts.set(o, e);
    }
  };
  addDesktopListeners() {
    this.desktopListenersAdded || (this.details?.addEventListener("toggle", this.onToggle), 
    this.megaMenu?.addEventListener("mouseover", this.handleSubMenuHover), this.megaMenu?.addEventListener("mouseout", this.handleSubMenuHover), 
    this.desktopListenersAdded = !0);
  }
  removeDesktopListeners() {
    this.desktopListenersAdded && (this.details?.removeEventListener("toggle", this.onToggle), 
    this.megaMenu?.removeEventListener("mouseover", this.handleSubMenuHover), this.megaMenu?.removeEventListener("mouseout", this.handleSubMenuHover), 
    document.removeEventListener("click", this.handleOutsideClick), this.desktopListenersAdded = !1);
  }
  close() {
    if (this.megaMenu && this.megaMenu.contains(document.activeElement)) {
      const e = this.details?.querySelector("summary");
      e && e.focus();
    }
    this.details?.hasAttribute("open") && this.details.removeAttribute("open");
  }
  clearAllFadeTimeouts() {
    this.fadeTimeouts.forEach(clearTimeout), this.fadeTimeouts.clear();
  }
});